import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { prefetchPetitionCommentPageDataFromApi, usePetitionCommentPageDataFromApi } from './pageData';

export type PetitionCommentPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof usePetitionCommentPageDataFromApi>[0]>;
}>;

export type PetitionCommentPageCombinedState = ReturnType<typeof usePetitionCommentPageDataFromApi>;

export function usePageContext(
	petitionSlug: string,
	commentId: string,
	prefetchedData?: PetitionCommentPagePrefetchedContext,
): PetitionCommentPageCombinedState {
	return usePetitionCommentPageDataFromApi(prefetchedData?.pageData, petitionSlug, commentId);
}

export async function prefetchPageContext(
	petitionSlug: string,
	commentId: string,
	context: PrefetchContext,
): Promise<PetitionCommentPagePrefetchedContext> {
	return { pageData: await prefetchPetitionCommentPageDataFromApi(context, petitionSlug, commentId) };
}

export type PetitionCommentPagePrefetchedDataProps = PrefetchedDataProps<PetitionCommentPagePrefetchedContext>;
